import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { I18nProvider } from "./i18n";
import { startAutoUpdate } from "./lib/autoUpdate";

// I18nProvider owns the MUI theme and CssBaseline now: the theme's direction
// (RTL for Dari/Pashto, LTR for English) follows the chosen locale.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </StrictMode>,
);

startAutoUpdate();
